// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const DoubleChevronLeft: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M11.308 17.616 6 12.308 11.308 7l.707.708-4.594 4.6 4.594 4.6-.707.707Zm6.1 0L12.1 12.308 17.408 7l.707.708-4.594 4.6 4.595 4.6-.708.707Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const DoubleChevronLeftOffset: IconOffset = {
    vertical: 25, // Store Custom Code
    horizontal: 25, // Store Custom Code
};

export default React.memo(DoubleChevronLeft);
